import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
import Coin from "../../../../Images/adhyayi_coin.png";
import heroImage from "../../../../Images/login1.png";
import axios from "../../../../axios";
import { ArrowUpRight, BookOpen, Loader2, Trophy, Users } from "lucide-react";
import ProfileAvatar from "../../../../componant/Avatar/ProfileAvatar";
import InstitutePhotos from "./InstitutePhotos";

const WelcomeCard = ({
  hasPurchased: purchasedFromParent = false,
  onStartMockTest,
  onViewMockReport,
  mockStarting = false,
  mockSubmitted = false,
}) => {
  const [hasPurchased,setHasPurchased] = useState(false);
  const [userData,setUserData] = useState(null);

  

   useEffect(()=>{
      try {
        axios.get("me").then((response)=>{
          const userData = response?.data?.result;
          if(userData){
            setUserData(userData);
            if(userData?.planName !== "Test"){
              setHasPurchased(true);
            }
          }
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }, []);

     const courseProgress = Math.floor(
    ((userData?.quizStats?.progressReport || 0)) 
   
    // ((userData?.quizStats?.totalRight || 0) / 100000) * 100
  );
   console.log(courseProgress,"courseProgress")

  const isPurchased = purchasedFromParent || hasPurchased;
  const mockButtonLabel = mockSubmitted ? "View Report" : "Start Mock Test";
  const handleMockButtonClick = mockSubmitted ? onViewMockReport : onStartMockTest;

  return (
    <>
    <div className="lg:hidden w-full bg-[#34163F] rounded-3xl px-4 py-4 sm:p-6 shadow-xl text-white">

      {/* Top Row */}
      <div className="flex items-center gap-4">
        {/* Profile Image */}
        <ProfileAvatar user={userData} className="h-14 w-14 shrink-0 text-lg" />

        {/* Text */}
        <div className="text-left flex-1">
          <p className="text-sm opacity-80">Welcome</p>
          <h2 className="text-sm sm:text-sm font-bold">
            {userData?.name || "User"}{" "}
          </h2>
        </div>
   
  </div>

    <div className="mt-2 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
  
  {/* Description */}
  {!isPurchased ? (
  <p className="text-sm sm:text-base opacity-90 leading-relaxed lg:text-left max-w-xl">
    Join million of people from around the world learning together,
    Online learning
  </p>
) : (
  <div className="w-full max-w-xl">
    
    {/* Progress Header */}
    <div className="flex justify-between  mb-2">
      <p className="text-sm sm:text-base font-medium text-white">

             {userData?.planName || "Free Plan"}
          
      </p>

     <p className="text-sm text-white-500">
  {courseProgress}
  %
</p>
    </div>

    {/* Progress Bar */}
    <div className="w-full h-2 bg-gray-300 rounded-full overflow-hidden">
      <div
        className="h-full bg-[#FF7A45] rounded-full transition-all duration-500"
        style={{ width: `${courseProgress}%` }}
      />
    </div>

  </div>
)}

  {/* Button */}
  <div className="flex items-center justify-center lg:justify-end">
    {isPurchased ? (
      <Link to="/dash/quize">
        <div className="flex items-center w-72 gap-3 bg-white text-[#2E174B] px-6 py-2 rounded-full font-semibold shadow-md hover:scale-95 transition">
          <button className="w-full flex items-center justify-center gap-2">
            Start Quiz
            <div className="bg-[#FF7A45] rounded-full p-1 text-white flex items-center justify-center">
              <ArrowUpRight />
            </div>
          </button>
        </div>
      </Link>
    ) : (
      <button
        type="button"
        disabled={mockStarting}
        onClick={handleMockButtonClick}
        className="flex w-72 items-center justify-center gap-3 rounded-full bg-white px-6 py-2 font-semibold text-[#2E174B] shadow-md transition hover:scale-95 disabled:cursor-not-allowed disabled:opacity-70"
      >
        {mockStarting ? (
          <>
            <Loader2 className="h-5 w-5 animate-spin" />
            Starting...
          </>
        ) : (
          <>
            {mockButtonLabel}
            <FaAngleRight />
          </>
        )}
      </button>
    )}
  </div>

</div>

    </div>
    <div className="hidden lg:block relative w-full min-h-[200px] overflow-hidden rounded-3xl bg-[#34163F] px-8 py-2 shadow-xl text-left text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_72%_45%,rgba(121,62,173,0.75),transparent_34%),radial-gradient(circle_at_38%_20%,rgba(255,122,69,0.12),transparent_26%)]" />

      <div className="relative z-10 grid min-h-[188px] grid-cols-[52%_48%] gap-5">
        <div className="max-w-xl text-left">
          <div className="flex items-center gap-4">
            <ProfileAvatar user={userData} className="h-14 w-14 shrink-0 text-lg" />
            <div>
              <p className="text-base text-white/85">Welcome back,</p>
              <h2 className="mt-1 text-xl font-bold leading-tight text-white">
                {userData?.name}
              </h2>
            </div>
          </div>
          <p className="mt-3 max-w-md text-sm leading-6 text-white/90">
            Join million of people from around the world learning together,
            Online learning
          </p>
  
  {!hasPurchased && (
          <div className="mt-4 grid max-w-sm grid-cols-3 gap-3">
            <div className="flex items-center gap-2 h-12 rounded-xl border border-white/10 bg-white/10 px-2.5 backdrop-blur">
  
  <Users className="h-5 w-5 text-[#D6B4FF]" />

  <div className="flex flex-col">
    <p className="text-md font-bold leading-none">10K+</p>
    <p className="mt-0.5 text-[10px] text-white/80">Students</p>
  </div>

</div>
           <div className="flex items-center gap-2 h-12 rounded-xl border border-white/10 bg-white/10 px-2.5 backdrop-blur">
  
  <Trophy className="h-5 w-5 text-[#FFB13B]" />

  <div className="flex flex-col">
    <p className="text-md font-bold leading-none">2L+</p>
    <p className="mt-0.5 text-[10px] text-white/80">Rewards Given</p>
  </div>

</div>

<div className="flex items-center gap-2 h-12 rounded-xl border border-white/10 bg-white/10 px-2.5 backdrop-blur">
  
  <BookOpen className="h-5 w-5 text-[#F3D7FF]" />

  <div className="flex flex-col">
    <p className="text-md font-bold leading-none">500+</p>
    <p className="mt-0.5 text-[10px] text-white/80">Courses</p>
  </div>

</div>
          </div>)}
          {hasPurchased && (
           <div className="mt-3 flex items-center gap-3">
                        <div className="h-1.5 flex-1 rounded-full bg-gray-100">
                          <div
                            className="h-full rounded-full bg-[#FF7A45]"
                            style={{ width: `${courseProgress}%` }}
                          />
                        </div>
                        <span className="text-xs font-semibold text-white">
                          {courseProgress}%
                        </span>
                      </div>)}
          {isPurchased ? (
            <Link
              to="/dash/quize"
              className="mt-5 flex h-10 w-64 items-center justify-center gap-3 rounded-xl bg-white text-sm font-semibold text-[#34163F] shadow-md transition hover:scale-[0.98]"
            >
              Start Quiz
              <ArrowUpRight className="h-5 w-5" />
            </Link>
          ) : (
            <button
              type="button"
              disabled={mockStarting}
              onClick={handleMockButtonClick}
              className="mt-5 flex h-10 w-64 items-center justify-center gap-3 rounded-xl bg-white text-sm font-semibold text-[#34163F] shadow-md transition hover:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-70"
            >
              {mockStarting ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  Starting...
                </>
                ) : (
                <>
                  {mockButtonLabel}
                  <FaAngleRight />
                </>
              )}
            </button>
          )}
        </div>

        <div className="relative flex h-full items-end justify-end">
          <img
            src={heroImage}
            alt=""
            className="relative z-10 h-[208px] w-full max-w-[360px] object-contain object-right-bottom"
          />
          <img
            src={Coin}
            alt=""
            className="absolute right-8 top-2 h-14 w-14 object-contain opacity-95"
          />
          <img
            src={Coin}
            alt=""
            className="absolute bottom-8 left-8 h-10 w-10 object-contain opacity-80"
          />
        </div>
      </div>
    </div>
    <InstitutePhotos user={userData} />
    </>
  );
};

export default WelcomeCard;
